var $a4988accc5a2bbb9$exports = {};
$a4988accc5a2bbb9$exports = {
    "Clear search": `Tyhjenn\xe4 haku`
};


export {$a4988accc5a2bbb9$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
